/* eslint-disable
    no-eq-null,
*/
import last from 'lodash/last'
import flow from 'lodash/fp/flow'
import mapFp from 'lodash/fp/map'
import filterFp from 'lodash/fp/filter'
import firstFp from 'lodash/fp/first'
import $ from 'jquery'

export default scrollToNext

/** @ngInject */
function scrollToNext(smoothScroll) {
    return ({
        restrict: 'A',
        link(scope, element, attr) {
            const selectors = attr.scrollToNext.split(' ')
            const offset = 72
            const threshold = 3
            const scrollToNextElement = function () {
                const windowOffsetTop = $(window).scrollTop()
                const $nextElement = flow(
          mapFp((selector) => $(selector)),
          filterFp(($element) => $element.offset() && ((windowOffsetTop) < ($element.offset().top - offset - threshold))),
          firstFp
        )(selectors)

                if ($nextElement != null) {
                    return smoothScroll($nextElement[0], { offset })
                }
            }

            const toggleScrollElementVisibility = function () {
                const $window = $(window)
                const $lastElement = $(last(selectors))
                if ($lastElement != null) {
                    const lastItemVisible = ($window.scrollTop() + $window.height()) > ($lastElement.offset().top + ($lastElement.height() / 2))
                    if (lastItemVisible) {
                        return element.hide()
                    }
                    return element.show()
                }
            }

            element.on('click.scrollToNext', scrollToNextElement)
            $(window).on('scroll.scrollToNext', toggleScrollElementVisibility)

            return scope.$on('$destroy', () => {
                element.off('.scrollToNext')
                return $(window).off('.scrollToNext')
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/scrollToNext/scrollToNext.js